<template>
  <DropDownButtonComponent
    :items="props.items"
    :select="onSelect"
    :css-class="_cssClass"
  >
    <v-icon
      v-if="_mdiIcon"
      :icon="_mdiIcon"
      :style="_mdiIconStyle"
      class="sog-button-mdi-icon"
    />
    <slot />
  </DropDownButtonComponent>
</template>

<script setup lang="ts">
import {DropDownButtonComponent} from "@syncfusion/ej2-vue-splitbuttons";
import {computed} from "vue";
import SogDropDownButtonItem from "@/shared/ui/types/SogDropDownButtonItem";
import {SogDropDownButtonType} from "@/shared/ui/types/SogDropDownButtonType";

interface Props {
  mdiIcon?: string
  items?: SogDropDownButtonItem[]
  type?: SogDropDownButtonType
}

const props = withDefaults(defineProps<Props>(), {
    mdiIcon: "", items: undefined, type: SogDropDownButtonType.Default
  }
)

const _emit = defineEmits<{ (e: 'select', item?: SogDropDownButtonItem): void }>()

/*
const  items=[
  {
    text: 'Cut'
  },
  {
    text: 'Copy'
  },
  {
    text: 'Paste'
  }]
*/

const _mdiIconStyle = computed(() => {
  return ""
  return "margin-right: 3px"
  //return "margin-right: 30px"
})


const _mdiIcon = computed(() => {
  if (props.mdiIcon)
    return props.mdiIcon
  return undefined
})

const _cssClass = computed(() => {
  switch (props.type) {
    case SogDropDownButtonType.Appbar:
      return "e-inherit e-appbar-menu";
    case SogDropDownButtonType.Card:
      return "e-card-btn";
    default:
      return ""
  }
})

function onSelect(args: any) {
  _emit("select", args.item)
}


</script>

<style scoped>
.sog-button-mdi-icon {
  margin-right: 3px;
}

</style>
